import {client} from './services/client'

export  const pharmaproduits = {
    namespaced:true,
    state:{
        pharmaproduits:[],
        pharmaproduitalls:undefined,
        pharmaproduitloading:true,
        mines:[],
        totalpage:[],
        overlay:true
    },
    mutations: {
        SET_PHARMAPRODUIT (state,pharmaproduits){
            state.pharmaproduits = pharmaproduits
        },
        SET_PHARMAPRODUITALL (state,pharmaproduits){
            state.pharmaproduitalls = pharmaproduits
        },
        SET_MINES (state,mines){
            state.mines = mines
        },
        SET_TOTAL (state,total){
            state.totalpage = total
        },

        SET_PHARMAPRODUITLOADING (state,total){
            state.pharmaproduitloading = total
        },
        SET_OVERLAY (state,val){
            state.overlay = val
        },

    },
    actions: {
        getPharmaProduits({commit},data){
            commit('SET_PHARMAPRODUITLOADING',true);
            commit('SET_OVERLAY',true);
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/pharmaproduits/get',
                    data:data
                }).then((response)=>{
                        let pharmaproduits = response.data.pharmaproduits;
                        let total = response.data.total;
                        console.log('pharmaproduits');
                        console.log(pharmaproduits);
                        commit('SET_PHARMAPRODUIT',pharmaproduits);
                        commit('SET_TOTAL',total);
                        commit('SET_PHARMAPRODUITLOADING',false);
                        commit('SET_OVERLAY',false);

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getPharmaProduitAlls({commit},data){
            commit('SET_OVERLAY',true);
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/pharmaproduits/getall',
                    data:data
                }).then((response)=>{
                        let pharmaproduits = response.data.pharmaproduits;
                       console.log("pharmaproduits",pharmaproduits);
                        commit('SET_PHARMAPRODUITALL',pharmaproduits);
                        commit('SET_OVERLAY',false);

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getSearch({commit},data){
            commit('SET_PHARMAPRODUITLOADING',true);
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/pharmaproduits/getSearch',
                    data:data
                }).then((response)=>{
                        let pharmaproduits = response.data.pharmaproduits;
                        console.log('pharmaproduits');
                        console.log(pharmaproduits);
                        commit('SET_PHARMAPRODUIT',pharmaproduits);
                        commit('SET_PHARMAPRODUITLOADING',false);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getOneChoose({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/pharmaproduits/getOneChoose/'+id,
                })
                    .then((response)=>{
                        let pharmaproduits = response.data.pharmaproduits;
                        console.log(pharmaproduits);
                        commit('SET_PHARMAPRODUIT',pharmaproduits)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getMineArray({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/pharmaproduits/getMineArray/'+id._id,
                })
                    .then((response)=>{
                        let mines = response.data.mines;
                        /*console.log('mines');
                        console.log(mines);*/
                        commit('SET_MINES',mines)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        getOncePharmaProduits({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/pharmaproduits/getOncePharmaProduits',
                    data:data,
                })
                    .then((response)=>{
                        let pharmaproduits = response.data.pharmaproduits;
                        commit('SET_PHARMAPRODUIT',pharmaproduits);
                        resolve(response);
                        console.log(pharmaproduits);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setUpdatePharmaProduit({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/pharmaproduits/update',
                    data:data,
                })
                    .then((response)=>{
                        let pharmaproduits = response.data.pharmaproduits;
                        commit('SET_PHARMAPRODUIT',pharmaproduits);
                        resolve(response);
                        console.log(pharmaproduits);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        setPharmaProduit({commit},data){
            commit('SET_OVERLAY',true);
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/pharmaproduits/save',
                    data:data,
                })
                    .then((response)=>{
                        let pharmaproduits = response.data.pharmaproduits;
                        commit('SET_PHARMAPRODUIT',pharmaproduits);
                        commit('SET_OVERLAY',false);
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deletePharmaProduit({commit},[id,pharmacie]){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/pharmaproduits/delete/'+id+'/'+pharmacie,
                })
                    .then((response)=>{
                        let pharmaproduits = response.data.pharmaproduits;
                        commit('SET_PHARMAPRODUIT',pharmaproduits);
                        console.log(pharmaproduits);

                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getPharmaProduits: state  => {
            return state.pharmaproduits
        },
        getMineArray: state  => {
            return state.mines
        },

    }
};
